<template>
  <div class="header" :style="pStyle">
    <div class="con flex_bet">
      <div class="logo">
        <!-- <img src="../assets/images/logo2.png" /> -->
        欢迎~
      </div>
      <ul class="nav">
        <router-link to="/">
          <li>
            <span>首页</span>
            <div class="nav_dot"></div>
          </li>
        </router-link>
        <router-link to="/make">
          <li>
            <span>配音制作</span>
            <div class="nav_dot"></div>
          </li>
        </router-link>
        <router-link to="/real">
          <li>
            <span>真人配音</span>
            <div class="nav_dot"></div>
          </li>
        </router-link>
        <router-link to="/tools">
          <li>
            <span>常用工具</span>
            <div class="nav_dot"></div>
          </li>
        </router-link>
        <!-- <li>
          <span>使用帮助</span>
          <div class="nav_dot"></div>
        </li> -->
        <router-link to="/aboutUs">
          <li>
            <span>关于我们</span>
            <div class="nav_dot"></div>
          </li>
        </router-link>
        <!-- <router-link to="/downapp">
        <li>
          <span>下载APP</span>
          <div class="nav_dot"></div>
        </li>
        </router-link> -->
      </ul>
      <div v-if="login_state">
        <div class="flex_ali">
          <!-- <router-link to="/viphub">
            <div class="usermod">
              <img src="../assets/images/user_vip.png" alt="" />
              <p>会员中心</p>
            </div>
          </router-link>
          <router-link to="/gold">
            <div class="usermod">
              <img src="../assets/images/user_money.png" alt="" />
              <p>金币充值</p>
            </div>
          </router-link>
          <router-link to="/stringpack" v-if="userrich.isvalidsvip=='1'">
            <div class="usermod">
              <img src="../assets/images/img2/string_apck.png" alt="" />
              <p>字符购买</p>
            </div>
          </router-link> -->
          <div class="user_avatar">
            <router-link to="/user"
              ><img
                src="../assets/images/img2/loginoff.png"
                class="user_avatarimg"
            /></router-link>
            <div class="user_ex_con">
              <div class="user_ex">
                <div class="user_extop">
                  <div class="user_extop_info">
                    <router-link to="/user"
                      ><img
                        src="../assets/images/img2/loginoff.png"
                        class="user_avatarimg"
                    /></router-link>
                    <div class="user_info">
                      <p>{{ userinfo.nickname }}</p>
                      <p>ID:{{ userinfo.id }}</p>
                    </div>
                  </div>
                  <!-- <div class="user_extop_text">
                    <div class="flex_ali">
                      <img
                        src="../assets/images/img2/userinfo1.png"
                        alt=""
                        class="user_infoicon"
                      />
                      <span
                        class="user_infotext"
                        v-if="
                          userrich.isvalidvip == '0' &&
                          userrich.isvalidsvip == '0'
                        "
                        >您还不是会员~</span
                      >
                      <span
                        class="user_infotext"
                        v-if="
                          userrich.isvalidvip == '1' &&
                          userrich.isvalidsvip == '0'
                        "
                        >{{ userrich.viptime.split(' ')[0] }}</span
                      >
                      <span
                        class="user_infotext"
                        v-if="userrich.isvalidsvip == '1'"
                        >{{ userrich.sviptime.split(' ')[0] }}</span
                      >
                    </div>
                    <div class="flex_ali">
                      <img
                        src="../assets/images/img2/userinfo2.png"
                        alt=""
                        class="user_infoicon"
                      />
                      <span class="user_infotext">{{ userrich.jb }}</span>
                    </div>
                  </div> -->
                </div>
                <div class="user_exlist">
                  <router-link to="/user/userreal">
                    <div class="user_exli">
                      <img src="../assets/images/img2/userex1.png" alt="" />
                      <span>真人订单</span>
                    </div>
                  </router-link>
                  <router-link to="/user/userworks">
                    <div class="user_exli">
                      <img src="../assets/images/img2/userex2.png" alt="" />
                      <span>合成配音</span>
                    </div>
                  </router-link>
                  <!-- <router-link to="/user/userbill">
                    <div class="user_exli">
                      <img src="../assets/images/img2/userex3.png" alt="" />
                      <span>我的账单</span>
                    </div>
                  </router-link> -->
                  <div class="user_exli" @click="exitLogin">
                    <img src="../assets/images/img2/userex4.png" alt="" />
                    <span>退出登录</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else @click="startLogin" style="cursor: pointer;">
        <img src="../assets/images/unLogin.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script scoped>
import { mapState } from "vuex";
export default {
  data() {
    return {
      pStyle: { background: "rgba(255, 255, 255, 0.6)" },
      headStyle1: { background: "rgba(255, 255, 255, 0.6)" },
      headStyle2: { background: "rgba(255, 255, 255, 1)" }
    };
  },
  computed: {
    ...mapState(["login_state", "userinfo", "userrich"])
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    // 退出登录
    exitLogin() {
      this.$globalFun.exitLogin(this);
    },
    // 开始登录
    startLogin() {
      this.$store.commit("setShowLogin", true);
    },
    //滚动事件
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop);
      if (scrollTop < 500) {
        this.pStyle = this.headStyle1;
      } else {
        this.pStyle = this.headStyle2;
      }
    }
  }
};
</script>

<style>
.user_ex_con {
  padding-top: 30px;
  position: absolute;
  right: 0;
  top: 40px;
  z-index: 9999;
}
.user_exli img {
  width: 20px;
  height: 20px;
  margin-right: 16px;
}
.user_exlist {
  padding: 8px 0;
}
.user_exli {
  display: flex;
  align-items: center;
  padding: 8px 20px;
  cursor: pointer;
}
.user_extop_text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
}
.user_extop_info {
  display: flex;
  align-items: center;
}
.user_infotext {
  font-size: 12px;
  color: #fff;
}
.user_infoicon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
.user_info {
  margin-left: 16px;
}
.user_info p {
  font-size: 12px;
}
.user_extop {
  width: 100%;
  height: 64px;
  background: linear-gradient(135deg, #ffbe0e 0%, #fe8a06 100%);
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 10px 20px;
}
.user_avatar:hover .user_ex {
  display: block;
}
.user_ex {
  box-shadow: 0px 40px 30px -30px rgba(0, 0, 0, 0.1);
  width: 220px;
  background-color: #fff;
  border-radius: 10px;
  display: none;
}
.user_ex::before {
  content: "";
  width: 25px;
  height: 25px;
  background: linear-gradient(-35deg, #ffbe0e 0%, #fe8a06 100%);
  position: absolute;
  right: 7px;
  top: 20px;
  transform: rotate(45deg);
  z-index: -1;
  content: "";
  width: 25px;
  height: 25px;
  background: linear-gradient(-35deg, #ffbe0e 0%, #fe8a06 100%);
  position: absolute;
  right: 7px;
  top: 21px;
  transform: rotate(45deg);
  z-index: -1;
}
.user_avatar {
  margin-left: 40px;
  position: relative;
}
.user_avatar .user_avatarimg {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background-color: #d8d8d8;
}
.usermod {
  text-align: center;
  margin-left: 20px;
}
.usermod img {
  width: 24px;
  height: 24px;
}
.usermod p {
  font-size: 12px;
  color: #333;
}
.nav_dot {
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background-color: #333;
  left: 50%;
  margin-left: -3px;
  bottom: 8px;
  display: none;
}
.nav .router-link-exact-active li {
  font-size: 18px;
  font-weight: bold;
  font-family: PingFangSC-Regular, PingFang SC;
}
.nav .router-link-exact-active .nav_dot {
  display: block;
}
.nav {
  height: 100%;
  display: flex;
  align-items: center;
}
.nav li {
  height: 100%;
  padding: 20px;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.logo p {
  color: #666;
}
h1 {
  font-size: 18px;
  font-weight: bold;
}
.logo img {
  width: auto;
  height: 40px;
  margin-right: 10px;
}
.logo {
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
}
.header {
  width: 100%;
  height: 60px;
  /* background-color: rgba(255, 255, 255, 0.6); */
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue